"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FileIcon;

var _react = _interopRequireDefault(require("react"));

function FileIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "14px",
    height: "17px",
    viewBox: "0 0 14 17",
    version: "1.1"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "components",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Components-FileSelector-",
    transform: "translate(-435.000000, -899.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group-46",
    transform: "translate(419.000000, 863.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "file",
    transform: "translate(16.000000, 36.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0.433622047,8.41555118 L0.433622047,15.8444094 C0.433622047,15.9634252 0.530708661,16.0616142 0.649685039,16.0616142 L4.09775591,16.0616142 L9.20232283,16.0616142 L9.93582677,16.0616142 L12.9414961,16.0616142 C13.0604724,16.0616142 13.1575197,15.9634252 13.1575197,15.8444094 L13.1575197,12.3541339 L13.1575197,2.71279528 L13.1575197,2.61228346 L10.9627559,2.61228346 C10.751378,2.61228346 10.3124016,2.64232283 10.3124016,2.16287402 L10.3077559,0.0196850394 L0.649645669,0.0196850394 C0.530669291,0.0196850394 0.433622047,0.116732283 0.433622047,0.235748031 L0.433622047,2.09007874 L0.433622047,2.87456693 L0.433622047,8.41555118 L0.433622047,8.41555118 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.1574803,12.3541339 L13.1574803,2.71279528 L13.1574803,2.61228346 L13.1574803,2.57877953 C13.1574803,2.51637795 13.1309055,2.50598425 13.0350394,2.41240157 L10.6658661,0.152559055 C10.5538189,0.0462598425 10.5353543,0.0196850394 10.4694882,0.0196850394 L10.3077559,0.0196850394 L0.649645669,0.0196850394 C0.530669291,0.0196850394 0.433622047,0.116732283 0.433622047,0.235748031 L0.433622047,15.8444094 C0.433622047,15.9634252 0.530669291,16.0616142 0.649645669,16.0616142 L12.9414567,16.0616142 C13.0604331,16.0616142 13.1574803,15.9634252 13.1574803,15.8444094 L13.1574803,12.3541339 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.1574803,12.3541339 L13.1574803,2.71279528 L13.1574803,2.61228346 C13.1574803,2.49559055 13.1193701,2.49444882 13.0350394,2.41240157 L10.6658661,0.152559055 C10.5538189,0.0462598425 10.5353543,0.0196850394 10.4694882,0.0196850394 L10.3077559,0.0196850394 L7.90389764,0.0196850394 C10.8414173,3.95248031 11.0088976,11.0416535 8.82917323,15.4666142 C8.72866142,15.6722835 8.62354331,15.8698425 8.5138189,16.0616142 L9.20228346,16.0616142 L9.9357874,16.0616142 L12.9414567,16.0616142 C13.0604331,16.0616142 13.1574803,15.9634252 13.1574803,15.8444094 L13.1574803,12.3541339 Z",
    id: "Path",
    fill: "#F8F8F8"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.3123622,2.16283465 C10.3123622,2.64228346 10.7512992,2.61224409 10.9627165,2.61224409 L13.1574803,2.61224409 L13.1574803,2.57874016 C13.1574803,2.51633858 13.1309055,2.50594488 13.0350394,2.4123622 L10.6658661,0.152519685 C10.5538189,0.0462204724 10.5353543,0.0196456693 10.4694882,0.0196456693 L10.3077559,0.0196456693 L10.3123622,2.16283465 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.0350394,2.41240157 L10.6658661,0.152559055 C10.5538189,0.0462598425 10.5353543,0.0196850394 10.4694882,0.0196850394 L10.3077559,0.0196850394 L10.3123622,2.16283465 C10.3123622,2.64228346 10.7512992,2.61224409 10.9627165,2.61224409 L13.1574803,2.61224409 L13.1574803,2.57874016 C13.1574803,2.51637795 13.1309055,2.50598425 13.0350394,2.41240157 Z",
    id: "Path",
    fill: "#B5C4CF"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.2052756,4.74433071 L2.50826772,4.74433071 C2.34027559,4.74433071 2.20409449,4.60811024 2.20409449,4.44003937 C2.20409449,4.2719685 2.34027559,4.13574803 2.50826772,4.13574803 L11.2052756,4.13574803 C11.3732677,4.13574803 11.5094488,4.2719685 11.5094488,4.44003937 C11.5094488,4.60811024 11.3733071,4.74433071 11.2052756,4.74433071 Z",
    id: "Path",
    fill: "#9AAFB7",
    fillRule: "nonzero"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.2052756,6.90594488 L2.50826772,6.90594488 C2.34027559,6.90594488 2.20409449,6.76972441 2.20409449,6.60165354 C2.20409449,6.43358268 2.34027559,6.2973622 2.50826772,6.2973622 L11.2052756,6.2973622 C11.3732677,6.2973622 11.5094488,6.43358268 11.5094488,6.60165354 C11.5094488,6.76972441 11.3733071,6.90594488 11.2052756,6.90594488 Z",
    id: "Path",
    fill: "#9AAFB7",
    fillRule: "nonzero"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.2052756,9.06759843 L2.50826772,9.06759843 C2.34027559,9.06759843 2.20409449,8.93137795 2.20409449,8.76330709 C2.20409449,8.59523622 2.34027559,8.45901575 2.50826772,8.45901575 L11.2052756,8.45901575 C11.3732677,8.45901575 11.5094488,8.59523622 11.5094488,8.76330709 C11.5094488,8.93137795 11.3733071,9.06759843 11.2052756,9.06759843 Z",
    id: "Path",
    fill: "#9AAFB7",
    fillRule: "nonzero"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.2052756,11.229252 L2.50826772,11.229252 C2.34027559,11.229252 2.20409449,11.0930315 2.20409449,10.9249606 C2.20409449,10.7568898 2.34027559,10.6206693 2.50826772,10.6206693 L11.2052756,10.6206693 C11.3732677,10.6206693 11.5094488,10.7568898 11.5094488,10.9249606 C11.5094488,11.0930315 11.3733071,11.229252 11.2052756,11.229252 Z",
    id: "Path",
    fill: "#9AAFB7",
    fillRule: "nonzero"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.2052756,13.3909055 L2.50826772,13.3909055 C2.34027559,13.3909055 2.20409449,13.254685 2.20409449,13.0866142 C2.20409449,12.9185433 2.34027559,12.7823228 2.50826772,12.7823228 L11.2052756,12.7823228 C11.3732677,12.7823228 11.5094488,12.9185433 11.5094488,13.0866142 C11.5094488,13.254685 11.3733071,13.3909055 11.2052756,13.3909055 Z",
    id: "Path",
    fill: "#9AAFB7",
    fillRule: "nonzero"
  }))))));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/FileSelector/icons/file.js
// module id = lCT1
// module chunks = 0